export const EmailJsConstants = {
    SERVICE_ID: 'service_onxluyr',
    TEMPLATE_ID: 'template_8df222i',
    PUBLIC_KEY: 'lAebPDM7628Mi6uC7',

}